import { propPanel as parentPropPanel } from '../text/propPanel';
export const propPanel = {
    schema: ({ options, i18n }) => {
        const { measurementPoints } = options;
        return {
            appRender: {
                type: 'object',
                properties: {
                    measurementPoint: {
                        title: i18n('schemas.measurementPoint'),
                        type: 'string',
                        widget: 'select',
                        span: 24,
                        props: {
                            options: measurementPoints.map(point => ({ label: point.label, value: point.id.toString() })),
                        },
                        required: true,
                    },
                }
            },
        };
    },
    widgets: {
        ...parentPropPanel.widgets,
    },
    defaultSchema: {
        ...parentPropPanel.defaultSchema,
        type: 'MeasurementPointChart',
        width: 24,
        height: 24,
        appRender: {
            measurementPoint: "",
        }
    },
};
//# sourceMappingURL=propPanel.js.map